"use client";

import { ReferenceChecker } from "@/components/tools/fake-citation-checker";

/**
 * `/verify-bibliography`: the Fake Citation Checker's reference checker with the APA
 * formatting pass and the manuscript sample. The page is English-only, so it renders
 * outside `ToolUiProvider` and the widget's English defaults apply.
 */
export function VerifyBibliography() {
  return <ReferenceChecker variant="audit" />;
}
